import { CardType } from "../../data";
import { mapSelectionNames } from "../mapSelectionNames";
import { mapMarketName } from "../mapMarketName";
const HeaderNamesMapper = {
    [CardType.Multiview]: (market, dict, sportId, isMainHeading) => isMainHeading
        ? mapMarketName(market, dict, sportId)
        : mapSelectionNames(market, dict),
    [CardType.American]: (market, dict, sportId) => mapMarketName(market, dict, sportId)
};
export const getHeaderNames = (config, dict, sportId, isMainHeading = false) => {
    const marketsNames = HeaderNamesMapper[config.cardType]
        ? config
            .markets
            .map((market) => HeaderNamesMapper[config.cardType](market, dict, sportId, isMainHeading))
        : [];
    return marketsNames;
};
//# sourceMappingURL=getHeaderNames.js.map